export const Global = {

  // API_URL: "http://localhost:5000/api/",
  // PHOTO_URL: "http://localhost:5000/Uploads/",
  API_URL: "https://api.playmegastorelb.com/api/",
  PHOTO_URL: "https://api.playmegastorelb.com/Uploads/",
  // PHOTO_URL: "http://localhost:44342/Uploads/Images/09_21_2022/",
};

// API_URL: "https://playapi.vision-more.com/api/",
// PHOTO_URL: "https://playapi.vision-more.com/Uploads/",